import { Button } from 'primereact/button';
import { ConfirmPopup } from 'primereact/confirmpopup';
import { IsNullOrEmpty } from "../../../services/CustomService";
import {
    useLoaderData,
    useRouteLoaderData,
    Form,
    Outlet
} from "react-router-dom";
import { getClient, getRentalsHistory, getVCard } from "../../../data/loca/clients";
import { getClientSatisfaction, surveyStatusLabel } from "../../../data/loca/satisfaction";
import { Stars, formatRate, formatScore } from "../satisfaction/SatisfactionStats";
import Moment from 'react-moment';
import { calendarStrings } from '../../../services/calendarStrings';
import '../../../assets/css/satisfaction.css';
export async function loader({ params }) {
    const [client, rentals, satisfaction] = await Promise.all([
        getClient(params.clientId),
        getRentalsHistory(params.clientId),
        getClientSatisfaction(params.clientId).catch(() => null)
    ]);

    return { client, rentals, satisfaction };
}

async function  vCard(client) {

    const vCard = await getVCard(client.publicId);
  
    const element = document.createElement("a");
    const file = new Blob([vCard], { type: "text/plain;charset=utf-8" });
    element.href = URL.createObjectURL(file);
    element.download = client.firstname + "_" + client.lastname + ".vcf";
    document.body.appendChild(element);
    element.click();
    return  vCard ;
}

const getClientInitials = (client) => {
    return `${client?.firstname?.[0] || ''}${client?.lastname?.[0] || ''}`.trim().toUpperCase() || '?';
};

const getRentalStatusLabel = (status) => {
    const labels = {
        Cancelled: "Annulée",
        Done: "Terminée",
        Draft: "Brouillon",
        Ongoing: "En cours",
        Reserved: "Réservée"
    };

    return labels[status] || status || "Non renseigné";
};

const renderSatisfactionCell = (survey) => {
    if (!survey) {
        return <span className="client-detail-status">—</span>;
    }
    if (survey.score != null) {
        return <span title={survey.comment || ""}><Stars score={survey.score} /> {survey.score}/5</span>;
    }
    return <span className="client-detail-status">{surveyStatusLabel(survey.status)}</span>;
};

const renderRentalsHistory = (rentals, amountWithoutCanceled, emptyMessage, satisfaction = null) => {
    if (rentals.length === 0) {
        return <p className="client-detail-empty">{emptyMessage}</p>;
    }

    const surveysByRental = {};
    (satisfaction?.surveys ?? []).forEach((survey) => {
        surveysByRental[survey.rentalPublicId] = survey;
    });

    return (
        <>
            <div className="client-detail-table-wrap">
                <table className="historyTable client-detail-history-table">
                    <thead>
                        <tr>
                            <th>Outil</th>
                            <th>Début</th>
                            <th>Fin</th>
                            <th>Prix</th>
                            <th>Statut</th>
                            <th>Satisfaction</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rentals.map((rental) => (
                            <tr key={rental.rentalPublicId}>
                                <td><a href={"/" + rental.rentalPublicId}>{rental.toolName}</a></td>
                                <td>{new Date(rental.startDate).toLocaleDateString()}</td>
                                <td>{new Date(rental.endDate).toLocaleDateString()}</td>
                                <td>{rental.totalAmount / 100}&euro;</td>
                                <td><span className="client-detail-status">{getRentalStatusLabel(rental.status)}</span></td>
                                <td>{renderSatisfactionCell(surveysByRental[rental.rentalPublicId])}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="client-detail-summary">
                <div>
                    <span>Total locations</span>
                    <strong>{rentals.length}</strong>
                </div>
                <div>
                    <span>Chiffre d'affaires</span>
                    <strong>{amountWithoutCanceled / 100}&euro;</strong>
                </div>
                <div>
                    <span>Satisfaction moyenne</span>
                    <strong>{formatScore(satisfaction?.averageScore)}</strong>
                </div>
                <div>
                    <span>Recommande le loueur</span>
                    <strong>{formatRate(satisfaction?.recommendRate)}</strong>
                </div>
            </div>
        </>
    );
};


export default function ClientLayout() {

    const { client } = useLoaderData();

    const addLocationToClient = () => {
        let link = `/ajouter/?clientId=${client.publicId}`
        //redirect to link
        //go
        window.location.href = link;
        
    };
    return (
        <div className="client-detail-page">
            <section className="client-detail-hero">
                <div className="client-detail-title">
                    <div className="client-detail-title-main">
                        <div className="client-detail-avatar">{getClientInitials(client)}</div>
                        <div>
                            <p className="tools-list-kicker">Client</p>
                            <h1>{client.firstname} {client.lastname}</h1>
                            <p>{client.email || "Email non renseigné"}</p>
                        </div>
                    </div>
                    <div className="client-detail-actions">
                        <Form action="modification">
                            <Button type="submit" icon="pi pi-pencil" size="small">Modifier le client</Button>
                        </Form>
                        <ConfirmPopup />
                        <Button onClick={() => vCard(client)} icon="pi pi-id-card" label="vCard" size="small" severity="secondary" outlined></Button>
                        <Button onClick={() => addLocationToClient()} icon="pi pi-plus" label="Location" size="small" severity="secondary" outlined></Button>
                    </div>
                </div>

                <div className="client-detail-meta">
                    <div>
                        <span>Email</span>
                        <strong>{client.email || "Non renseigné"}</strong>
                    </div>
                    <div>
                        <span>Téléphone</span>
                        <strong>{client.phone || "Non renseigné"}</strong>
                    </div>
                    <div>
                        <span>Adresse</span>
                        <strong>{client.address || "Non renseignée"}</strong>
                    </div>
                    {(client.birthdate) && (
                        <div>
                            <span>Date de naissance</span>
                            <strong>
                                <Moment locale="fr" calendar={calendarStrings}>
                                    {new Date(client.birthdate)}
                                </Moment>
                                {!IsNullOrEmpty(client.birthplace) && (
                                    <span> à {client.birthplace}</span>
                                )}
                            </strong>
                        </div>
                    )}
                </div>
            </section>
            <div id="mainContent" className="client-detail-main">
                <Outlet />
            </div>
    </div>
    );
}

export function ClientDetailsPage() {
    const { client, rentals = [], satisfaction = null } = useRouteLoaderData("client-detail") ?? {};
    const amountWithoutCanceled = rentals.reduce((acc, rental) => {
        if (rental.status !== 'Cancelled') {
            return acc + rental.totalAmount;
        }
        return acc;
    }, 0);
    const clientComments = (satisfaction?.surveys ?? []).filter((survey) => !IsNullOrEmpty(survey.comment));

    return (
        <section className="client-detail-content">
            <div className="client-detail-card">
                <h2>Commentaires</h2>
                {(IsNullOrEmpty(client.comment)) ? (

                    <p className="client-detail-empty">Aucun commentaire</p>
                ) : (<p className="client-detail-comment">{client.comment}</p>)}

            </div>

            <div className="client-detail-card">
                <h2>Retours du locataire</h2>
                {(satisfaction?.completedCount ?? 0) === 0 ? (
                    <p className="client-detail-empty">Aucun questionnaire de satisfaction complété</p>
                ) : (
                    <>
                        <p className="client-detail-comment">
                            <Stars score={satisfaction.averageScore} /> {formatScore(satisfaction.averageScore)} en moyenne sur {satisfaction.completedCount} questionnaire{satisfaction.completedCount > 1 ? "s" : ""}
                            {satisfaction.recommendRate != null ? ` · recommande le loueur : ${formatRate(satisfaction.recommendRate)}` : ""}
                        </p>
                        {clientComments.length > 0 && (
                            <ul className="sat-comments">
                                {clientComments.map((survey) => (
                                    <li key={survey.rentalPublicId}>
                                        <p>{survey.comment}</p>
                                        <small>
                                            {survey.score != null && <><Stars score={survey.score} /> · </>}
                                            {survey.toolName} · {new Date(survey.endDate).toLocaleDateString("fr-FR")}
                                            {" · "}<a href={`/${survey.rentalPublicId}`}>voir la location</a>
                                        </small>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </>
                )}
            </div>

            <div className="client-detail-card client-detail-card-full">
                <h2>Historique des locations</h2>
                {renderRentalsHistory(rentals, amountWithoutCanceled, "Aucune location pour ce client", satisfaction)}
            </div>
        </section>
    );
}

export function ClientHistoryPage() {
    const { rentals = [], satisfaction = null } = useRouteLoaderData("client-detail") ?? {};
    const amountWithoutCanceled = rentals.reduce((acc, rental) => {
        if (rental.status !== 'Cancelled') {
            return acc + rental.totalAmount;
        }
        return acc;
    }, 0);

    return (
        <section className="client-detail-content">
            <div className="client-detail-card client-detail-card-full">
                <h2>Historique</h2>
                {renderRentalsHistory(rentals, amountWithoutCanceled, "Aucune location pour ce client", satisfaction)}
            </div>
        </section>
    );
}
